import { render, staticRenderFns } from "./detailTableTitle.vue?vue&type=template&id=68bfb378&scoped=true"
import script from "./detailTableTitle.vue?vue&type=script&lang=js"
export * from "./detailTableTitle.vue?vue&type=script&lang=js"
import style0 from "./detailTableTitle.vue?vue&type=style&index=0&id=68bfb378&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68bfb378",
  null
  
)

export default component.exports